import React from 'react';

import { DiscountedText, DiscountedWrapper, WrapperDiscount } from './styled';

interface DiscountedBoxProps {
  type?: string;
  rate?: number;
  rateType?: string;
  currencyName?: string;
}

const DiscountedBox = ({
  type,
  rate,
  rateType,
  currencyName,
}: DiscountedBoxProps) => {
  return (
    <WrapperDiscount>
      {type === 'PerRoom' ? (
        <DiscountedWrapper>
          {rateType === 'Percentage' ? (
            <DiscountedText>Oda Başı {rate} % İndirim</DiscountedText>
          ) : (
            <DiscountedText>
              Oda Başı {rate} {currencyName} İndirim
            </DiscountedText>
          )}
        </DiscountedWrapper>
      ) : (
        <DiscountedWrapper>
          {rateType === 'Percentage' ? (
            <DiscountedText>Kişi Başı {rate} % İndirim</DiscountedText>
          ) : (
            <DiscountedText>
              Kişi Başı {rate} {currencyName} İndirim
            </DiscountedText>
          )}
        </DiscountedWrapper>
      )}
    </WrapperDiscount>
  );
};

export default DiscountedBox;
